import {ThemeProvider as ThemeVarsProvider} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import type {Theme} from '@mui/material/styles';
import type {ThemeProviderProps as MuiThemeProviderProps} from '@mui/material/styles/ThemeProvider';

import {defaultSettings} from '@minimal/components/settings';
import {useTranslate} from '@minimal/locales';

import {createTheme} from './create-theme';
import type {} from './extend-theme-types';
import type {ThemeOptions} from './types';

// ----------------------------------------------------------------------

export type ThemeProviderProps = Omit<MuiThemeProviderProps, 'theme'> & {
  theme?: Theme;
  themeOverrides?: ThemeOptions;
};

export function ThemeProvider({themeOverrides, children, ...other}: ThemeProviderProps) {
  const {currentLang} = useTranslate();

  const theme = createTheme({
    settingsState: defaultSettings,
    localeComponents: currentLang?.systemValue,
    themeOverrides,
  });

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      {children}
    </ThemeVarsProvider>
  );
}
